import { Box, Text } from '@chakra-ui/react';
import CachedImage from './CachedImage';

interface VideoElementProps {
  videoId: string;
  title: string;
  thumbnail?: string;
  subtitles?: string[];
  isValidVideoSource: (src: string) => boolean;
  videoRef: React.RefObject<HTMLVideoElement>;
}

const VideoElement: React.FC<VideoElementProps> = ({
  videoId,
  title,
  thumbnail,
  subtitles = [],
  isValidVideoSource,
  videoRef
}) => {
  if (videoId && isValidVideoSource(videoId)) {
    return (
      <video
        ref={videoRef}
        src={videoId}
        poster={thumbnail}
        crossOrigin="anonymous"
        style={{ 
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%', 
          height: '100%', 
          objectFit: 'cover',
          imageRendering: 'auto'
        }}
        playsInline
        preload="metadata"
      >
        {subtitles.map((subtitleUrl, index) => (
          <track
            key={index}
            kind="subtitles"
            src={subtitleUrl}
            srcLang="en"
            label="English"
            default={index === 0}
          />
        ))}
      </video>
    );
  }

  return (
    <>
      {thumbnail && (
        <CachedImage
          src={thumbnail}
          alt={title}
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          objectFit="cover"
          fallbackType="video"
        />
      )}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        textAlign="center"
        color="white"
        zIndex={5}
      >
        <Text fontSize="lg" fontWeight="bold" mb={2}>Invalid Video Source</Text>
        <Text fontSize="sm" opacity={0.8}>The video URL is not valid or accessible</Text>
      </Box>
    </>
  );
};

export default VideoElement;
